var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatreon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399414 12.2351C0.399414 6.83654 4.78606 1.77476 10.5705 1.05165C14.7162 0.569416 17.8495 2.16055 20.0184 4.23295C22.0428 6.16092 23.2486 8.61959 23.5375 11.512C23.7784 14.404 23.1522 16.9106 21.4651 19.2729C19.778 21.5871 16.4518 24.1418 12.306 24.1418H6.66605V13.0067C6.71452 10.5481 7.53359 8.42719 10.5225 7.41474C13.1256 6.64365 16.1625 8.08938 17.0785 10.8374C18.0424 13.7778 16.6442 15.7543 15.0056 16.9596C13.3669 18.1649 10.8118 18.1649 9.12472 17.0081V20.816C10.2336 21.3462 11.6314 21.4907 12.6438 21.4427C16.3069 20.912 19.1513 18.8396 20.3567 15.7063C21.6105 12.3801 20.742 8.52364 18.1394 6.11343C15.0061 3.55831 11.5834 2.93164 7.91987 4.71568C5.36523 6.01747 3.58169 8.66855 3.14743 11.5605V24.1422H0.447883L0.399414 12.2351Z",
    fill: "#FF5900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreon);
export default __webpack_public_path__ + "static/media/patreon.f60a60b4.svg";
export { ForwardRef as ReactComponent };